export default {
  computed: {
    device() {
      return this.$store.state.app.device;
    },
  },
  mounted() {

  },
  methods: {
    fixBugIniOS() {
      const $subMenu = this.$refs.subMenu;
      if ($subMenu) {
        const handleMouseleave = $subMenu.handleMouseleave;
        $subMenu.handleMouseleave = () => {
          if (this.device === 'mobile') {
            return;
          }
          handleMouseleave();
        };
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/layout/components/Sidebar/FixiOSBug.js